// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitDepartureAirport__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitDepartureAirport/SearchUnitDepartureAirport.scss
 ** module id = 936
 ** module chunks = 1
 **/